module.exports = __webpack_public_path__ + "static/media/BalancoFinanc1.086763bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/RelBalancoFinanc/BalancoFinanc1.png
// module id = 2170
// module chunks = 0